import axios from "axios";

export default async function getStats() {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/stats`,{
            withCredentials: true,
            validateStatus: () => true,
        });

        return {
            ok: res.status >= 200 && res.status < 300,
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        return { ok: false, status: 0, error: err.message };
    }
}
